// extracted by mini-css-extract-plugin
export default {"container":"Hero_container__3tRUA","row":"Hero_row__Peary","col_header":"Hero_col_header__L2og0","col_img":"Hero_col_img__YUAX2"};